import React, { useEffect, useState } from 'react';
import { Table, Button, Row, notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import { generateInvoice, showIFS } from '@app/api/prImportFreeSales.api';

interface Invoice {
  id: number;
  invoice_number: string;
  total: string;
  status: string;
  created_at: string;
}

interface PaymentsInfoProps {
  id: string | null;
  pr_code: string | null;
  PRstatus: string | null;
  invoice_data: Invoice[];
  wfActions: string[];
  InvoiceActions: Record<string, boolean>;
  invoicetype?: string | null;
  total?: string | number | null;
}

const PaymentsInfo: React.FC<PaymentsInfoProps> = ({
  id,
  pr_code,
  invoice_data,
  PRstatus,
  wfActions,
  InvoiceActions,
  invoicetype,
  total,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [invoiceData, setInvoiceData] = useState<Invoice[]>([]);
  console.log('InvoiceActions:', InvoiceActions);

  useEffect(() => {
    setInvoiceData(invoice_data);
  }, [invoice_data]);

  const showInvoice = (invoiceId: number, status: string, invoice_number: string) => {
    if (id !== null) {
      localStorage.removeItem('isLab');
      navigate(`/view-invoice`, {
        state: { id, pr_code, invoiceId, status, invoice_number, PRstatus, wfActions, total },
      });
    } else {
      notification.error({ message: 'Error', description: 'Invalid ID or Invoice' });
    }
  };

  const handleGenerateInvoice = async (invoiceType: 'APPLICATION' | 'CERTIFICATE') => {
    if (!id) {
      notification.error({ message: 'Error', description: 'Invalid ID' });
      return;
    }

    try {
      setLoading(true);
      const result = await generateInvoice(Number(id), invoiceType);
      notification.success({
        message: 'Invoice Generated',
        description: `Invoice created successfully (${invoiceType})`,
      });
      console.log('Generated Invoice:', result);
      const res = await showIFS(Number(id));
      setInvoiceData(res?.product_registration?.invoices ?? []);
    } catch (err) {
      notification.error({
        message: 'Error',
        description: 'Failed to generate invoice',
      });
    } finally {
      setLoading(false);
    }
  };

  const invoiceColumns = [
    {
      title: 'Invoice Number',
      dataIndex: 'invoice_number',
      key: 'invoice_number',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => <span style={{ color: status === 'PAID' ? 'green' : 'red' }}>{status}</span>,
    },
    {
      title: 'Total (LKR)',
      dataIndex: 'total',
      key: 'total',
    },
    {
      title: 'Action',
      key: 'action',
      render: (record: Invoice) => (
        <Row align="middle">
          <Button
            size="small"
            type="primary"
            onClick={() => showInvoice(record.id, record.status, record.invoice_number)}
          >
            View
          </Button>
        </Row>
      ),
    },
  ];

  const showApplicationButton = InvoiceActions.APPLICATION && invoiceData.length === 0;
  const showCertificateButton = InvoiceActions.CERTIFICATE && invoiceData.length === 0;

  return (
    <>
      <h3>Invoices</h3>

      {showApplicationButton && (
        <div style={{ marginBottom: '8px' }}>
          <Button type="primary" size="small" loading={loading} onClick={() => handleGenerateInvoice('APPLICATION')}>
            Generate Application Invoice
          </Button>
        </div>
      )}

      {showCertificateButton && (
        <div style={{ marginBottom: '16px' }}>
          <Button type="primary" size="small" loading={loading} onClick={() => handleGenerateInvoice('CERTIFICATE')}>
            Generate Certificate Payment Invoice
          </Button>
        </div>
      )}

      <Table dataSource={invoiceData} columns={invoiceColumns} rowKey="id" />

      <h3>Receipts</h3>
      <p>No receipts available yet.</p>
    </>
  );
};

export default PaymentsInfo;
